<!-- main-top-navigation -->
<!--<div class="top-navigation main-top-navigation d-none d-lg-block">-->
<!--<ul class="navtop-wrap list-unstyled my-0">-->
<!--<li *ngFor="let level1 of topNavigation" class="level-1">-->
<!--<a *ngIf="level1.children.length === 0"-->
<!--routerLink="{{level1.url}}"-->
<!--translate>-->
<!--{{level1.name}}-->
<!--</a>-->
<!--<a *ngIf="level1.children.length > 0"-->
<!--id="dLabel"-->
<!--data-toggle="dropdown"-->
<!--aria-expanded="false"-->
<!--translate>-->
<!--{{level1.name}}-->
<!--</a>-->
<!--<section *ngIf="level1.children.length > 0" class="level-2 list-unstyled"-->
<!--class="dropdown-menu" aria-labelledby="dLabel">-->
<!--<div *ngFor="let level2 of level1.children" class="level-2-wrap">-->
<!--<a routerLink="{{level2.url}}" translate>-->
<!--{{level2.name}}-->
<!--</a>-->
<!--<div *ngIf="level2.slices && level2.slices.length > 0" class="level-3 d-flex">-->
<!--<ul *ngFor="let slice of level2.slices" class="list-unstyled">-->
<!--<li *ngFor="let child of slice">-->
<!--<a routerLink="{{child.url}}" translate>-->
<!--{{child.name}}-->
<!--</a>-->
<!--</li>-->
<!--</ul>-->
<!--</div>-->
<!--</div>-->
<!--</section>-->
<!--</li>-->
<!--</ul>-->
<!--</div>-->
<!-- end main-top-navigation -->



<div class="top-navigation main-top-navigation d-none d-lg-block">
  <ul class="navtop-wrap list-unstyled my-0 p-0">
    @for (level1 of topNavigation; track level1) {
      <li class="level-1" dropdown>
        @if (level1.children.length === 0) {
          <a
            routerLink="{{level1.url}}"
            translate>
            {{level1.name}}
          </a>
        }
        @if (level1.children.length > 0) {
          <a
            id="button-basic"
            dropdownToggle
            class="dropdown-toggle"
            aria-controls="dropdown-basic"
            translate>
            {{level1.name}}
          </a>
        }
        @if (level1.children.length > 0) {
          <section class="level-2 list-unstyled"
            id="dropdown-basic"
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="button-basic">
            @for (level2 of level1.children; track level2) {
              <div class="level-2-wrap">
                <a routerLink="{{level2.url}}" translate>
                  {{level2.name}}
                </a>
                @if (level2.slices && level2.slices.length > 0) {
                  <div class="level-3 d-flex">
                    @for (slice of level2.slices; track slice) {
                      <ul class="list-unstyled p-0">
                        @for (child of slice; track child) {
                          <li>
                            <a routerLink="{{child.url}}" translate>
                              {{child.name}}
                            </a>
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
              </div>
            }
          </section>
        }
      </li>
    }
  </ul>
</div>